"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyValue = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const Shape_1 = require("lincd/lib/shapes/Shape");
let PropertyValue = class PropertyValue extends Shape_1.Shape {
    get value() {
        return this.getValue(schema_1.schema.value);
    }
    set value(val) {
        this.overwrite(schema_1.schema.value, new models_1.Literal(val.toString()));
    }
    get propertyID() {
        return this.getOne(schema_1.schema.propertyID);
    }
    set propertyID(val) {
        this.overwrite(schema_1.schema.propertyID, val);
    }
};
PropertyValue.targetClass = schema_1.schema.PropertyValue;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.value,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PropertyValue.prototype, "value", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.propertyID,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], PropertyValue.prototype, "propertyID", null);
PropertyValue = __decorate([
    package_1.linkedShape
], PropertyValue);
exports.PropertyValue = PropertyValue;
//# sourceMappingURL=PropertyValue.js.map